import React, { useEffect } from "react";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { Image } from "antd";
import shield from "../../assets/svg/shield.svg";
import buy from "../../assets/svg/buy.svg";
import tick from "../../assets/svg/tick.svg";
import { ProductWrapper } from "../../lib/styles/styleLibrary";
import { currency } from "../../lib/helpers/currencySymbol";
import { truncate } from "../../lib/helpers/helpers";

const ProductItem = (props) => {
	const { gifted, item, selectedItem, setSelectedItem, setViewItem } = props;
	useEffect(() => {}, [selectedItem]);
	return (
		<div
			tw="flex flex-col h-72 w-full md:w-48   rounded-custom hover:(shadow-lg)"
			onClick={() => setSelectedItem(item)}>
			<ProductWrapper
				onClick={() => setViewItem(true)}
				style={{ minHeight: "12rem", backgroundColor: "#ddd" }}
				bg={props.src}
				tw="w-full md:w-48 h-96 md:h-44 shadow-custom flex items-center justify-center">
				{/* <div tw="absolute top-2 right-2 rounded-2xl p-0.5 bg-white inline-flex items-center justify-center hover:(shadow-lg)">
					<Image
						preview={false}
						src={share}
						alt=""
						className="image-pixelated"
						tw="h-6 w-6 p-1"
					/>
				</div> */}

				{gifted && (
					<span tw="bg-appGray-80 rounded-custom h-16 w-24 text-white flex flex-col gap-1 items-center justify-center">
						<Image
							preview={false}
							src={shield}
							alt=""
							className="image-pixelated"
						/>
						<span tw="text-sm font-semibold">GIFTED</span>
					</span>
				)}
			</ProductWrapper>
			<div tw="p-1">
				<div tw="text-sm font-semibold mt-2 opacity-50 h-10">
					{truncate(props.name, 45)}
				</div>
				<div tw="mt-1 flex flex-row flex-nowrap gap-4 items-center justify-between">
					<span tw="font-semibold text-sm">
						{currency()} {props.price}
					</span>
					<span
						onClick={() =>
							window.open(`${props.gift_link}`, "_blank")
						}
						tw=" p-1.5 rounded-full h-8 w-8 bg-appGray-10 hover:cursor-pointer inline-flex items-center justify-center">
						{gifted ? (
							<Image
								preview={false}
								src={tick}
								alt=""
								width="14"
								height="11"
								// tw="p-1.5 rounded-full bg-appGray-10 hover:cursor-pointer"
								className="image-pixelated"
							/>
						) : (
							<Image
								preview={false}
								src={buy}
								alt=""
								width="18"
								height="18"
								tw=""
								className="image-pixelated"
							/>
						)}
					</span>
				</div>
			</div>
		</div>
	);
};

export default ProductItem;
